import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Navigate } from "react-router-dom";
import Spinner from "../components/Spinner";
import { getSession, getStorefrontAvailability } from "./api";

const RestaurantDefaultRoute = () => {
    const availabilityQuery = useQuery(
        ["restaurantStorefront", "availability"],
        getStorefrontAvailability,
        {
            retry: false,
            staleTime: 30 * 1000,
        }
    );
    const sessionQuery = useQuery(
        ["restaurantStorefront", "session"],
        getSession,
        { retry: false, staleTime: 0 }
    );

    if (sessionQuery.isLoading) {
        return <Spinner />;
    }
    if (sessionQuery.data?.user_type === "System User") {
        return <Navigate to="/auth-login" replace />;
    }
    if (availabilityQuery.isLoading) {
        return <Spinner />;
    }

    const destination =
        !availabilityQuery.isError && availabilityQuery.data?.enabled
            ? "/restaurant-store"
            : "/auth-login";

    return <Navigate to={destination} replace />;
};

export default RestaurantDefaultRoute;
